<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/promotion/promoAccount")
          i.fas.fa-list
          span.ml-1 {{ $t("ui.promotion_account") }}
      b-breadcrumb-item(v-if="currOperator && pageLvl != 'opr' && getAccountType == 3")
        i.fa.fa-user
        span.ml-1 {{ currOperator.account_id }}
  div.row
    div.col-md-12
      div.card
        div.card-header(v-if="getAccountType == 3 && pageLvl == 'opr'")
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getOperatorList()"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.mb-1(v-if="pageLvl == 'opr' && getAccountType == 3")
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalOprRow"
                  :per-page="getPageSize"
                  v-model="currentOprPage"
                  @input="changedOprPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedOprPageSize")
          div.mb-1(v-if="pageLvl == 'pack'")
            div.mb-1(v-if="getAccountType == 3")
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToOperatorLvl"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalPackRow"
                  :per-page="getPageSize"
                  v-model="currentPackPage"
                  @input="changedPackPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPackPageSize")
          div.row.clusterize
            div.col-md-12(v-if="pageLvl=='opr' && getAccountType == 3")
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id', 'opr')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id', 'opr')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('profile_id', 'opr')")
                        span(:title="$t('ui.profile_id')") {{ $t('ui.profile_id') }}
                        i(:class="changeSortKey('profile_id', 'opr')")
                      th.sticky-position.sortable(width="23%" @click="sortOrder('full_name', 'opr')")
                        span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                        i(:class="changeSortKey('full_name', 'opr')")
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                      th.sticky-position(width="15%")
                        span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                      th.sticky-position(width="7%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      th.text-right.sticky-position.sortable(width="13%" @click="sortOrder('created_date', 'opr')")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date', 'opr')")
                  tbody.clusterize-content
                    tr(v-if="filteredOperatorList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filteredOperatorList" :class="$helpers.rowClass(item)")
                      td
                        span(:title="((currentOprPage - 1) * getPageSize + index + 1)") {{ ((currentOprPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id")
                          b-link.clickable(href="javascript:void(0);" @click="setOperatorAccId(item, true)") {{ item.account_id }}
                      td
                        span(:title="item.profile_id") {{ item.profile_id }}
                      td
                        span(:title="item.full_name") {{ item.full_name }}
                      td
                        span(:title="item.contact_phone") {{ item.contact_phone }}
                      td
                        span(:title="item.last_login_ip") {{ item.last_login_ip }}
                      td
                        span(:title="item.status") {{ item.status }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
            div.col-md-12(v-if="currOperator && pageLvl=='pack'")
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="9%" @click="sortOrder('promo_id', 'pack')")
                        span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
                        i(:class="changeSortKey('promo_id', 'pack')")
                      th.sticky-position.sortable(width="9%" @click="sortOrder('package_id', 'pack')")
                        span(:title="$t('ui.package_id')") {{ $t('ui.package_id') }}
                        i(:class="changeSortKey('package_id', 'pack')")
                      th.sticky-position.sortable(width="9%" @click="sortOrder('package_name', 'pack')")
                        span(:title="$t('ui.package_name')") {{ $t('ui.package_name') }}
                        i(:class="changeSortKey('package_name', 'pack')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('claim_type', 'pack')")
                        span(:title="$t('ui.claim_type')") {{ $t('ui.claim_type') }}
                        i(:class="changeSortKey('claim_type', 'pack')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('min_deposit', 'pack')")
                        span(:title="$t('ui.min_deposit')") {{ $t('ui.min_deposit') }}
                        i(:class="changeSortKey('min_deposit', 'pack')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('bonus_rate', 'pack')")
                        span(:title="$t('ui.bonus_rate')") {{ $t("ui.bonus_rate") }}
                        i(:class="changeSortKey('bonus_rate', 'pack')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('max_bonus', 'pack')")
                        span(:title="$t('ui.max_bonus')") {{ $t("ui.max_bonus") }}
                        i(:class="changeSortKey('max_bonus', 'pack')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('rollover', 'pack')")
                        span(:title="$t('ui.rollover')") {{ $t("ui.rollover") }}
                        i(:class="changeSortKey('rollover', 'pack')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('criteria', 'pack')")
                        span(:title="$t('ui.criteria')") {{ $t("ui.criteria") }}
                        i(:class="changeSortKey('criteria', 'pack')")
                      th.sticky-position.text-center(width="6%")
                        span(:title="$t('ui.provider_status')") {{ $t("ui.short.provider_status") }}
                      th.sticky-position.text-center.sticky-toggle(width="6%")
                        span(:title="$t('ui.own_status')") {{ $t("ui.short.own_status") }}
                      th.text-right.sticky-position.sortable(width="6%" @click="sortOrder('start_date', 'pack')")
                        span(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                        i(:class="changeSortKey('start_date', 'pack')")
                      th.text-right.sticky-position.sortable(width="6%" @click="sortOrder('end_date', 'pack')")
                        span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                        i(:class="changeSortKey('end_date', 'pack')")
                  tbody.clusterize-content
                    tr(v-if="promoAccountList.length == 0")
                      td(colspan="14").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in promoAccountList" :class="$helpers.rowClassBit(item.own_status)")
                      td
                        span(:title="((currentPackPage - 1) * getPageSize + index + 1)") {{ ((currentPackPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.promo_id") {{ item.promo_id }}
                      td
                        span(:title="item.package_id") {{ item.package_id }}
                      td
                        span(:title="item.package_name") {{ item.package_name }}
                      td
                        span(:title="item.claim_type") {{ item.claim_type }}
                      td
                        span(:title="$n(item.min_deposit, 'currency')") {{ $n(item.min_deposit, 'currency') }}
                      td
                        span(:title="$n(item.bonus_rate, 'currency')") {{ $n(item.bonus_rate, 'currency') }}
                      td
                        span(:title="$n(item.max_bonus, 'currency')") {{ $n(item.max_bonus, 'currency') }}
                      td
                        span(:title="$n(item.rollover, 'currency')") {{ $n(item.rollover, 'currency') }}
                      td
                        span(:title="item.criteria") {{ item.criteria }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.provider_status, 'fas fa-times text-warning': !item.provider_status  }")
                      td
                        div.d-flex.justify-content-center.align-items-center
                          label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                            input.switch-input(type="checkbox" v-model="item.own_status" @change="changedOwnStatus(item, $event)")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                      td.text-right
                        span(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                      td.text-right
                        span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
  },
  data: () => ({
    loading: false,
    operatorList: [],
    promoAccountList: [],
    currentOprPage: 1,
    totalOprRow: 0,
    currentPackPage: 1,
    totalPackRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    pageLvl: 'opr',
    currOperator: null,
    oprSortKey: "account_id",
    oprSortType: "asc",
    packSortKey: "promo_id",
    packSortType: "asc",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredOperatorList() {
      return this.operatorList.filter(function(obj) {
        return obj.self_operate == false;
      })
    },
    getAccountType() {
      if (this.$store.getters.account[0])
        return this.$store.getters.account[0].account_type;

      return 0;
    },
  },
  mounted: function() {
    if(this.$store.getters.account[0]) {
      if (this.$store.getters.account[0].account_type == 2) {
        this.currOperator = this.$store.getters.account[0];
        this.pageLvl = 'pack';
        this.getPromoAccountList(true);
      } else if (this.$store.getters.account[0].account_type == 3) {
        this.getOperatorList(true);
      }
    }
  },
  methods: {
    sortOrder(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey == key)
          this.oprSortType = this.oprSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.oprSortKey = key;
          this.oprSortType = 'asc';
        }
        this.getOperatorList(true);
      } else if (type == 'pack') {
        if (this.packSortKey == key)
          this.packSortType = this.packSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.packSortKey = key;
          this.packSortType = 'asc';
        }
        this.getPromoAccountList(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'opr') {
        if (this.oprSortKey != key)
          return 'fas fa-sort';
        else if (this.oprSortKey == key && this.oprSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.oprSortKey == key && this.oprSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'pack') {
        if (this.packSortKey != key)
          return 'fas fa-sort';
        else if (this.packSortKey == key && this.packSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.packSortKey == key && this.packSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    backToOperatorLvl() {
      this.pageLvl = "opr";
      this.search = "";
      this.promoAccountList = [];
      this.currOperator = null;
    },
    getOperatorList: function(isSearch) {
      this.pageLvl = 'opr';

      let url = config.accountListUrl();

      if (isSearch) this.currentOprPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_key: this.oprSortKey,
        sort_type: this.oprSortType,
        page_number: this.currentOprPage,
        page_size: this.getPageSize
      };


      if (this.search.trim() != '') {
        json.search_id = this.search;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorList = response.data.dt;
                this.totalOprRow = this.operatorList.length > 0 ? this.operatorList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setOperatorAccId: function (item) {
      this.currOperator = item;
      this.search = "";
      this.getPromoAccountList(true);
    },
    getPromoAccountList: function(isSearch) {
      let url = config.promoAccountListUrl();

      if (isSearch) this.currentPackPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.currOperator.account_id,
        sort_key: this.packSortKey,
        sort_type: this.packSortType,
        page_number: this.currentPackPage,
        page_size: this.getPageSize,
        source_account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = 'pack';
                this.promoAccountList = response.data.dt;
                this.totalPackRow = this.promoAccountList.length > 0 ? this.promoAccountList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedOwnStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.package_own_status"),
          text: this.$t("message.change_package_own_status_confirm", { name: item.package_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmOwnStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.own_status;
            item.own_status = !item.own_status;
          }
        });
    },
    confirmOwnStatus: function(item, status) {
      let url = config.promoPackageStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: this.currOperator.account_id,
        package_id: item.package_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.own_status = status;
                this.$helpers.showDialog(this.$t("ui.package_own_status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedOprPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentOprPage = 1;
      this.getOperatorList(true);
    },
    changedOprPage: function(pageNo) {
      this.currentOprPage = pageNo;
      this.getOperatorList();
    },
    changedPackPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPackPage = 1;
      this.getPromoAccountList(true);
    },
    changedPackPage: function(pageNo) {
      this.currentPackPage = pageNo;
      this.getPromoAccountList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>